import { Provider } from '@angular/core';

import { VideoRepositoryImpl } from '@app/data/repositories/multimedia/video/video.repository';
import { VIDEO_REPOSITORY } from '@app/domain/repositories/multimedia/video/video.repository.contract';

export const videoRepositoryProvider: Provider = {
  provide: VIDEO_REPOSITORY,
  useClass: VideoRepositoryImpl
};
